import { render, staticRenderFns } from "./BePaymentCard.vue?vue&type=template&id=b059dc90&scoped=true"
import script from "./BePaymentCard.vue?vue&type=script&lang=js"
export * from "./BePaymentCard.vue?vue&type=script&lang=js"
import style0 from "./BePaymentCard.vue?vue&type=style&index=0&id=b059dc90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b059dc90",
  null
  
)

export default component.exports